// Core
import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  // Link
} from "react-router-dom";
// Pages
import Authenticated from './pages/Authenticated';
import Unsub from './pages/Unsub'
import Survey from './pages/Survey'
import Header from './components/header';
import Error from './pages/Error'
// Custom
import querystring from 'query-string'; // fix for url parsing in ie11
// Styling
import 'bootstrap/dist/css/bootstrap.min.css';
// Fonts
import './assets/fonts/rcu-fonts.css'

const App = () => {
  const urlString = window.location.search;
  const query = querystring.parse(urlString);
  const error = Object.keys(query).length > 0 ? false : true;
  return (
    <>
      { error &&
        <>
          <Header />
          <Error message="An Error Occured" subMessage="Not enough parameters provided." />
        </>
      }
      { !error && 
        <Router basename="/preferences">
          <Switch>
            <Route path="/employee">
              <Authenticated query={query} channel="RCU"/>
            </Route>
            <Route path="/olb">
              <Authenticated query={query} channel="OLB"/>
            </Route>
            <Route path="/mobile">
              <Authenticated query={query} channel="MOB"/>
            </Route>
            <Route path="/nps">
              <Survey query={query} channel="EUNSUB"/>
            </Route>
            <Route path="/">
              <Unsub query={query} />
            </Route>
          </Switch>
        </Router>
      }
    </>
  );
}

export default App;